/* angular:styles/component:scss;e43ee6c5e76c9de80fa22c7b90026cbadd8ca988768beff295ca8ac062c7e453;/home/vsts/work/1/s/Autocare.Api/ClientApp/src/app/module/service-provider/custom-input-number.ts */
.custom-input-number {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border: 1px solid #dfe1e5;
  border-radius: 8px;
  margin-bottom: 10px;
  background-color: #fff;
}
.icon-wrapper {
  background-color: #F2F4F7;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
}
.icon-left {
  font-size: 1rem;
  color: #6c757d;
}
.custom-input-number label {
  flex: 1;
  margin-right: 10px;
}
.custom-input-number ::ng-deep p-inputNumber {
  flex: 2;
}
::ng-deep .p-inputnumber-buttons-horizontal {
  border: 1px solid #FD7809;
  border-radius: 8px;
}
.custom-input-number ::ng-deep p-inputNumber input {
  width: 50px !important;
  height: 40px !important;
  background-color: #FCE9CF;
  color: #FD7809;
  text-align: center;
  border: none;
  border-radius: 0px;
}
.custom-input-number ::ng-deep .p-inputnumber-button {
  width: 30px !important;
  height: 40px !important;
}
.custom-input-number ::ng-deep .p-inputnumber-button .pi {
  font-size: 12px;
}
::ng-deep .p-button.p-button-success {
  color: #FD7809;
  background: #FCE9CF;
  border: none;
  padding: 6px 10px;
  border-radius: 0px 8px 8px 0px;
}
::ng-deep .p-button.p-button-danger {
  color: #FD7809;
  background: #FCE9CF;
  border: none;
  padding: 6px 10px;
  border-radius: 8px 0px 0px 8px;
}
:host ::ng-deep .p-inputtext:hover {
  background-color: #FCE9CF;
  box-shadow: none;
}
::ng-deep input.p-inputtext:hover {
  box-shadow: none !important;
}
/*# sourceMappingURL=custom-input-number-SFRW2UH4.css.map */
